class CustomQuantityTins {
    constructor() {
        this.wrapper = document.querySelector("[data-custom-quantity-tins]");
        if(!this.wrapper) return;
        this.buttons = this.wrapper.querySelectorAll("button[value]");
        this.productSection = this.wrapper.closest(".header-product");

        this.init();
    }

    init() {
        window.purchaseType = "default";

        [...this.buttons].forEach(button => {
            button.addEventListener("click", (e) => {
                this.setInputQuantity(+e.target.value);
            });
        });

        document.addEventListener("click", (e) => {
            if (e.target.closest("[data-selling-plan-button]")) {
                this.hideBlock();
                window.purchaseType = "subscription";
                this.setInputQuantity(1);
            }

            if (e.target.closest("[data-default-button-subs]")) {
                this.showBlock();
                window.purchaseType = "default";
                this.setInputQuantity(1);
            }
        })
    }

    hideBlock() {
        if (!this.wrapper.classList.contains("hidden")) {
            this.wrapper.classList.add("hidden");
        }
    }

    showBlock() {
        if (this.wrapper.classList.contains("hidden")) {
            this.wrapper.classList.remove("hidden");
        }
    }

    setInputQuantity(value) {
        if (this.productSection && value) {
            this.quantityPickerInput = this.productSection.querySelector("input[data-quantity-picker-input]");
            
            if (this.quantityPickerInput) {
                this.quantityPickerInput.value = value;
                this.quantityPickerInput.dispatchEvent(new Event("input", { bubbles: true }));
            }
        }
    }
}

new CustomQuantityTins();